import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import PrivateRoute from './components/PrivateRoute'
import Navbar from './components/Navbar'
import Home from './pages/Home'
import Login from './pages/Login'
import Register from './pages/Register'
import Dashboard from './pages/Dashboard'
import Courses from './pages/Courses'
import CourseDetail from './pages/CourseDetail'
import MyCourses from './pages/MyCourses'
import CreateCourse from './pages/CreateCourse'
import ManageCourse from './pages/ManageCourse'
import CourseStudents from './pages/CourseStudents'
import Profile from './pages/Profile'
import Assignments from './pages/Assignments'
import AssignmentDetail from './pages/AssignmentDetail'
import GradeAssignment from './pages/GradeAssignment'
import Quizzes from './pages/Quizzes'
import TakeQuiz from './pages/TakeQuiz'
import QuizResults from './pages/QuizResults'

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className='min-h-screen bg-gray-50'>
          <Navbar />
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/login' element={<Login />} />
            <Route path='/register' element={<Register />} />
            <Route
              path='/dashboard'
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path='/courses'
              element={
                <PrivateRoute>
                  <Courses />
                </PrivateRoute>
              }
            />
            <Route
              path='/courses/:id'
              element={
                <PrivateRoute>
                  <CourseDetail />
                </PrivateRoute>
              }
            />
            <Route
              path='/courses/:id/manage'
              element={
                <PrivateRoute>
                  <ManageCourse />
                </PrivateRoute>
              }
            />
            <Route
              path='/courses/:id/students'
              element={
                <PrivateRoute>
                  <CourseStudents />
                </PrivateRoute>
              }
            />
            <Route
              path='/my-courses'
              element={
                <PrivateRoute>
                  <MyCourses />
                </PrivateRoute>
              }
            />
            <Route
              path='/create-course'
              element={
                <PrivateRoute>
                  <CreateCourse />
                </PrivateRoute>
              }
            />
            <Route
              path='/assignments'
              element={
                <PrivateRoute>
                  <Assignments />
                </PrivateRoute>
              }
            />
            <Route
              path='/assignments/:id'
              element={
                <PrivateRoute>
                  <AssignmentDetail />
                </PrivateRoute>
              }
            />
            <Route
              path='/assignments/:id/grade'
              element={
                <PrivateRoute>
                  <GradeAssignment />
                </PrivateRoute>
              }
            />
            <Route
              path='/quizzes'
              element={
                <PrivateRoute>
                  <Quizzes />
                </PrivateRoute>
              }
            />
            <Route
              path='/quizzes/:id/take'
              element={
                <PrivateRoute>
                  <TakeQuiz />
                </PrivateRoute>
              }
            />
            <Route
              path='/quizzes/:id/results'
              element={
                <PrivateRoute>
                  <QuizResults />
                </PrivateRoute>
              }
            />
            <Route
              path='/profile'
              element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  )
}

export default App
